import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React, { useState, Fragment } from "react";
import { useSelector } from "react-redux";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Collapse from "@mui/material/Collapse";
import moment from "moment";
import {
  GetHistoryTimerSumJSON,
  LatestDataColoring,
} from "../utils/systemInfo";

import OpsumService from "../api/opsum";
import TableGreenTypography from "../common/TableGreenTypography";
import StyledTypography from "../common/StyledTypography";
import OpsumTotalsComparisonProgress from "../common/opsumTotalsComparisonProgress";
import OpsumHistoryTotals from "../common/opsumHistoryTotals";
import ViewButton from "../common/viewButton";
import HistoryButton from "../common/historyButton";
import CollapseButton from "../common/collapseButton";
import PropTypes from "prop-types";

const opsumTotalsComparisonList = [
  {
    id: 0,
    tittle: "Powered",
    valueName: "powered",
    valueLabel: "Hours",
    compareReverse: false,
  },
  {
    id: 0,
    tittle: "EngineRun",
    valueName: "engine_run",
    valueLabel: "Hours",
    compareReverse: false,
  },
  {
    id: 0,
    tittle: "Tramming",
    valueName: "tramming",
    valueLabel: "Hours",
    compareReverse: false,
  },
  {
    id: 0,
    tittle: "EnginerWorking",
    valueName: "high_rpm",
    valueLabel: "Hours",
    compareReverse: false,
  },
  {
    id: 0,
    tittle: "Forward",
    valueName: "forward",
    valueLabel: "Hours",
    compareReverse: false,
  },
  {
    id: 0,
    tittle: "Reverse",
    valueName: "reverse",
    valueLabel: "Hours",
    compareReverse: false,
  },
];
export default function MonitoringTableRow({
  row,
  handleClick,
  handleArrowIcon,
  isItemSelected,
  labelId,
  dateFromBefore,
  dateFrom,
  dateto,
  handleView,
}) {
  const [open, setOpen] = useState(false);
  const [deviceHistoryTotals, setDeviceHistoryTotals] = useState(undefined);
  const [compareDeviceHistoryTotals, setCompareDeviceHistoryTotals] =
    useState(undefined);
  const [productionJson, setProductionJson] = useState(undefined);
  const [scheduledTime, setScheduledTime] = useState(undefined);
  const { t } = useTranslation();
  const theme = useTheme();
  const organziation = useSelector(({ organziation }) => organziation);
  const timezoneMins = useSelector(({ timezone }) => timezone);

  function handleOpenCollapse() {
    if (!open) {
      const apiKey = organziation?.api_key_list?.[0]?.key;
      OpsumService.GetDeviceOpsumTimers({
        deviceID: row.DeviceID,
        deviceType: [
          "nerohub",
          "nanohub",
          "cyberhub",
          "stratahub",
          "nerotrax",
          "train",
          "autonomous hub",
        ],
        apiKey,
        historyFromDST: dateFrom,
        historyToDST: dateto,
      })
        .then((jsonCurrent) => {
          const DeviceHistoryTotals = GetHistoryTimerSumJSON(
            jsonCurrent.opsum.device[0].data,
            dateFrom,
            dateto
          );
          setDeviceHistoryTotals(DeviceHistoryTotals);
          setProductionJson(jsonCurrent.opsum.device[0].production);
          setScheduledTime(jsonCurrent.scheduled_time.scheduled);
          OpsumService.GetDeviceOpsumTimers({
            deviceID: "",
            deviceType: [
              "nerohub",
              "nanohub",
              "cyberhub",
              "stratahub",
              "nerotrax",
              "train",
              "autonomous hub",
            ],
            apiKey,
            historyFromDST: dateFromBefore,
            historyToDST: dateFrom,
          })
            .then((jsonPrevious) => {
              const CompareDeviceHistoryTotals = GetHistoryTimerSumJSON(
                jsonPrevious.opsum.device[0].data,
                dateFromBefore,
                dateFrom
              );
              setCompareDeviceHistoryTotals(CompareDeviceHistoryTotals);
            })
            .catch((errorr) => {
              if (process.env.NODE_ENV === "development")
                console.log("getUserTypePermissionserrorr", errorr);
            });
        })
        .catch((errorr) => {
          if (process.env.NODE_ENV === "development")
            console.log("getUserTypePermissionserrorr", errorr);
        });
    }
    setOpen(!open);
  }
  return (
    <Fragment>
      <TableRow
        hover
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.name}
        selected={isItemSelected}
        sx={{ cursor: "pointer" }}
      >
        <TableCell>
          <CollapseButton handleOpenCollapse={handleOpenCollapse} open={open} />
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.DeviceName)}
          sx={{ height: "100%", color: theme.palette.custom.text }}
          component="th"
          id={labelId}
          scope="row"
          padding="none"
        >
          <Box
            sx={{
              textAlign: "center",
              width: "100%",
              display: "flex",
              flexFlow: "row",
              justifyContent: "space-around",
            }}
          >
            <div
              style={{ width: "40px" }}
              dangerouslySetInnerHTML={{
                __html: row.DeviceTypeIcon.replace(
                  "theme.palette.custom.text",
                  theme.palette.custom.text
                ),
              }}
            />{" "}
            <StyledTypography variant="subtitle2">
              {row.DeviceName}
            </StyledTypography>{" "}
          </Box>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.DeviceName)}
          align="left"
        >
          <StyledTypography variant="subtitle2">
            {row.DeviceStatus}
          </StyledTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.DeviceName)}
          align="left"
        >
          <TableGreenTypography
            color={LatestDataColoring(row.DeviceLatestRaw, true)}
            variant="subtitle2"
          >
            {row.DeviceLatestRaw
              ? moment
                  .utc(row.DeviceLatestRaw)
                  .add(timezoneMins, "minutes")
                  .format("YYYY-MM-DD HH:mm")
              : row.DeviceLatestRaw}
          </TableGreenTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.DeviceName)}
          align="left"
        >
          <TableGreenTypography
            color={LatestDataColoring(row.DeviceLatestOPSUM, true)}
            variant="subtitle2"
          >
            {row.DeviceLatestOPSUM
              ? moment
                  .utc(row.DeviceLatestOPSUM)
                  .add(timezoneMins, "minutes")
                  .format("YYYY-MM-DD HH:mm")
              : row.DeviceLatestOPSUM}
          </TableGreenTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.DeviceName)}
          align="left"
        >
          <TableGreenTypography
            color={LatestDataColoring(row.DeviceLastSeen, true)}
            variant="subtitle2"
          >
            {row.DeviceLastSeen
              ? moment
                  .utc(row.DeviceLastSeen)
                  .add(timezoneMins, "minutes")
                  .format("YYYY-MM-DD HH:mm")
              : row.DeviceLastSeen}
          </TableGreenTypography>
        </TableCell>
        <TableCell
          onClick={(event) => handleClick(event, row.DeviceName)}
          align="left"
        >
          {row.NamedLocationOriginal === "Unknown" ? (
            <TableGreenTypography
              sx={{
                color: "red",
              }}
              variant="subtitle2"
            >
              {row.NamedLocationOriginal}
            </TableGreenTypography>
          ) : (
            <StyledTypography variant="subtitle2">
              {row.NamedLocationOriginal}
            </StyledTypography>
          )}
        </TableCell>
        <TableCell align="center">
          <Box
            sx={{
              textAlign: "center",
              width: "100%",
              display: "flex",
              flexFlow: "row",
            }}
          >
            <ViewButton onClick={(event) => handleView(event, row)} />
            <HistoryButton device={row} />
          </Box>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography
                sx={{
                  color: theme.palette.custom.text,
                  fontSize: "1.25rem",
                  fontWeight: 400,
                }}
                gutterBottom
                component="div"
              >
                {`${t("OPSUM DATA FOR")}:${row.DeviceName}`}
              </Typography>
              <OpsumHistoryTotals
                opsumTotalsComparisonList={opsumTotalsComparisonList}
                deviceHistoryTotals={deviceHistoryTotals}
                compareDeviceHistoryTotals={compareDeviceHistoryTotals}
                handleArrowIcon={handleArrowIcon}
              />
              <Box sx={{ textAlign: "center", width: "100%" }}>
                {productionJson && scheduledTime ? (
                  // <div style={{ width: '100%',height: '75px' }} dangerouslySetInnerHTML={{
                  //     __html: (GetDeviceOpsumTotalsComparisonProgressHTML(productionJson, scheduledTime))
                  // }} />
                  <OpsumTotalsComparisonProgress
                    ProductionJson={productionJson}
                    scheduled_time={scheduledTime}
                  />
                ) : null}
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
MonitoringTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
  handleArrowIcon: PropTypes.func,
  handleView: PropTypes.func,
  labelId: PropTypes.string,
  dateFromBefore: PropTypes.string,
  dateFrom: PropTypes.string,
  dateto: PropTypes.string,
  isItemSelected: PropTypes.bool,
};
